module.exports = __webpack_public_path__ + "static/img/multiply@3x.c6bfc89.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/gloable/multiply@3x.png
// module id = 1026
// module chunks = 67